import { safeArrayAccess } from '../util/safeArrayAccess';

/**
 * Returns an array that gives for each 0-based sample index
 * the 0-based chunk index it belongs to.
 */
export function buildChunkIndexes(
  first_chunk: number[],
  samples_per_chunk: number[],
  sampleCount: number,
): number[] {
  const chunkIndexes: number[] = [];
  let sampleIndex = 0;

  for (let i = 0; i < samples_per_chunk.length; i++) {
    const nextBatchChunk = (i === samples_per_chunk.length - 1) ? (sampleCount + 1) : safeArrayAccess(first_chunk, i + 1);

    for (let currentChunk = safeArrayAccess(first_chunk, i); currentChunk < nextBatchChunk && sampleIndex < sampleCount; currentChunk++) {
      for (let j = 0; j < safeArrayAccess(samples_per_chunk, i) && sampleIndex < sampleCount; j++) {
        // Chunks are indexed from 1 in the stsc mp4 box, so we adjust to
        // index from 0
        chunkIndexes[sampleIndex++] = currentChunk - 1;
      }
    }
  }

  return chunkIndexes;
}

